import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { POC_LISTING, UPDATE_POC_STATUS } from "./type";

export const getPocListing = (leadId, page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.viewPoc.list}?lead_id=${leadId}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_LISTING, payload: data.response.data });
    return true;
  }
};

export const updatePocStatus = (data) => async (dispatch) => {
  const res = await callWebService(callTypes.put, data, Config.viewPoc.status);
  if (res) {
    const { data } = res;
    dispatch({ type: UPDATE_POC_STATUS, payload: data.response.status });
    return true;
  }
};
